/**
 * @def BiImage에 사용되는 background color map 입니다.
 * key-value 규칙은 아래와 같습니다.
 * --------- | key                | value           |
 * default   | 그룹사 명          | 기본 색 코드    |
 * exception | 그룹사 + 금융 타입 | 색상 코드       |
 *
 * default 예시 - 1) KB: '#776d62' / 2) KAKAO: '#fee200' (금융 타입을 제외하고 corp 네임만 넣어주세요)
 * 예외케이스 예시 - 1) CAPITAL_HYUNDAI_COMMERCIAL: '#e9530c' / 2) CD_CITI_BANK: '#00abe2',
 */
const BACKGROUND_COLOR_CODE_MAP = {
  WHITE: '#fff',
  BLACK: '#000',
  KB: '#776d62',
  SHINHAN: '#0046ff',
  // 신한,제주
  HANA: '#009178',
  WOORI: '#00a0ff',
  KAKAO: '#ffe400',
  KAKAOFIRE: '#fae100',
  KAKAOIV: '#ffcd00',
  // 카카오페이증권
  K: '#120064',
  IBK: '#004898',
  NH: '#005bac',
  NHCENTRAL: '#04a64b',
  KDB: '#00367f',
  SC: '#0075f2',
  BNK: '#d51d1e',
  // BNK(부산,경남)
  IM: '#00C7A9',
  // iM뱅크(대구은행), iM캐피탈(DGB캐피탈), iM뱅크 카드(대구카드)
  DGB: '#004181',
  // 하이투자, DGB생명
  SH: '#0068b6',
  // SH수협, 수협중앙회
  JB: '#00286c',
  // JB(광주,전북)
  EPOST: '#e72410',
  TOSS: '#0064ff',
  KOSAF: '#0085cb',
  KFCC: '#0b376a',
  CU: '#0056a7',
  CITI: '#00abe2',
  MIRAE: '#ef8200',
  KIWOOM: '#003e79',
  SAMSUNG: '#003de5',
  DAISHIN: '#0073CF',
  // 대신저축
  DAISHINIV: '#4c4d4f',
  // 대신증권
  YUANTA: '#0066b2',
  HM: '#002d74',
  HANWHA: '#e87127',
  SK: '#ea002c',
  KTB: '#1c2372',
  DAOL: '#000',
  /** @deprecated 포스증권이 우리 증권으로 변경됨. */
  FOSS: '#003894',
  MERITZ: '#ee3b23',
  LOTTE: '#54565A',
  ACUON: '#4ebc29',
  OK: '#524749',
  BC: '#e73e44',
  HEUNGKUK: '#e4007f',
  SSIN: '#00b4ae',
  JT: '#00abed',
  SBI: '#005da0',
  DONGWONJEIL: '#ca8426',
  LENDIT: '#00d0b3',
  AXA: '#153278',
  AIG: '#00a0e9',
  CARROT: '#ff4600',
  BNP: '#00925c',
  LINA: '#150f9b',
  DONGYANG: '#0099d9',
  AIA: '#c10230',
  ABL: '#e72410',
  TOYOTA: '#e60020',
  VOLKSWAGEN: '#012257',
  KICF: '#221e1f',
  MASON: '#d7294d',
  ECO: '#8dc63f',
  CNH: '#122130',
  HF: '#0054a2',
  CD_HYUNDAI: '#231f20',
  CD_HYUNDAI_DS: '#231815',
  CD_GALLERIA_DS: '#221e1f',
  CAPITAL_HYUNDAI_COMMERCIAL: '#e9530c',
  CAPITAL_HYUNDAI: '#3d7cc9',
  CAPITAL_KIWWOOM: '#001e5a',
  PEPPER: '#e10613',
  KOREAINVEST: '#632d00',
  HB: '#0d6fb8',
  KOOKJE: '#4b360d',
  NAMYANG: '#ff0018',
  DAEBAEK: '#00419f',
  DONGYANGSB: '#0054A5',
  // 동양저축
  RAON: '#004daf',
  MUSTSAMIL: '#ed0022',
  MK: '#170181',
  BARO: '#022f5e',
  OHTOO: '#007fe9',
  /**
   * @deprecated 이베스트증권이 LS증권으로 사명이 변경되었습니다. IV_LS를 사용해주세요.
   */
  EBEST: '#003378',
  LS: '#003378',
  EUGENE: '#be1e24',
  SHINYOUNG: '#004710',
  HANKUK: '#003389',
  CD_KOREAINVEST: '#221e1f',
  CD_NH: '#0078C1',
  BOOKOOK: '#214498',
  KOREAASSET: '#e31736',
  KR: '#0853AE',
  HSBC: '#d0121b',
  PRUDENTIAL: '#0C6eb4',
  FSB: '#254F41',
  // 저축은행중앙회
  DEUTSCH: '#0518a1',
  // 도이치은행
  JPMORGAN: '#2c5aaf',
  // JP모간
  BOA: '#f8002d',
  // BOA
  ICBC: '#ab1416',
  // 중국공상
  CCB: '#3147a4',
  // 중국건설
  CHINA: '#B0013F',
  // 중국은행
  NAVERPAY: '#00DE5A',
  // 네이버페이
  NFCF: '#00b8ac',
  // 산림조합중앙회
  KINFA: '#00418e',
  // 서민금융진흥원
  CAPE: '#005ea4',
  // 케이프투자증권
  DBFI: '#00723a',
  // DB금융투자
  DS: '#1d1d1b',
  // DS투자증권
  HANYANG: '#1d3772',
  // 한양증권
  KYOBO: '#00457c',
  // 교보증권
  LEADING: '#ff000d',
  // 리딩투자증권
  YUHWA: '#130082',
  // 유화증권
  EXIM: '#0183c1',
  // 한국수출입은행
  IS_HI: '#f18d00',
  // 현대해상
  VISA: '#1434CB',
  // 비자
  MASTER_CARD: '#000000' // 마스터
};

export { BACKGROUND_COLOR_CODE_MAP };
